import React, { FunctionComponent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Descriptions } from 'antd';
import { useStore } from '@hub/helpers/use-store';
import { Card, Statistic } from '@monorepo/react-components';

interface Props {
  programId: string;
  title: string;
  profitAndLoss: number;
  extra?: ReactNode;
}

const AccountTarget: FunctionComponent<Props> = ({
  programId,
  title,
  profitAndLoss,
  extra,
}) => {
  const {
    dataStore: { programStore },
  } = useStore();
  const { t } = useTranslation(['common']);

  const program = programStore.get(programId);

  const target = program?.config?.target || 0;

  return (
    <Card title={title} extra={extra}>
      <Descriptions column={1}>
        <Descriptions.Item label={t('common:minimum')}>
          <Statistic prefix={'$'} value={target} precision={0} />
        </Descriptions.Item>
        <Descriptions.Item label={t('common:current')}>
          <Statistic prefix={'$'} value={profitAndLoss} precision={2} />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default AccountTarget;
